"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Title = exports.HiddenInput = exports.FilesWrapper = exports.FilePreview = exports.FileName = exports.Error = exports.Description = exports.CloseButton = exports.ButtonWrapper = exports.BrowseButton = void 0;
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _polished = require("polished");
var _IoCloseSharp = require("@react-icons/all-files/io5/IoCloseSharp");
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const Wrapper = _styledComponents.default.div`
  ${({
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    border-radius: ${theme.border.radius.default};
    border: 0.1rem solid ${(0, _polished.lighten)(0.8, theme.colors.primaryDark)};
    margin: ${theme.spacings.small} 0rem;
    padding: ${theme.spacings.medium};
    width: 100%;
    gap: ${theme.spacings.small};
  `}
`;
exports.Wrapper = Wrapper;
const Title = _styledComponents.default.h3`
  ${({
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    font-family: ${theme.fonts.family.montserrat};
    font-size: ${theme.fonts.sizes.medium};
    font-weight: ${theme.fonts.weight.semiBold};
    line-height: 1;
    text-transform: uppercase;
  `}
`;
exports.Title = Title;
const Description = _styledComponents.default.p`
  ${({
  theme
}) => (0, _styledComponents.css)`
    color: ${(0, _polished.lighten)(0.3, theme.colors.primaryDark)};
    font-size: ${theme.fonts.sizes.small};
    white-space: pre-line;
  `}
`;
exports.Description = Description;
const ButtonWrapper = _styledComponents.default.div`
  ${({
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    align-items: center;
    gap: 1rem;
    font-size: ${theme.fonts.sizes.small};
    font-weight: ${theme.fonts.weight.medium};
  `}
`;
exports.ButtonWrapper = ButtonWrapper;
const BrowseButton = (0, _styledComponents.default)(_Button.default)`
  ${({
  theme
}) => (0, _styledComponents.css)`
    font-weight: ${theme.fonts.weight.medium};
    font-size: ${theme.fonts.sizes.small};
    min-height: fit-content;
    min-width: fit-content;
    padding: 0.8rem 1rem;
  `}
`;
exports.BrowseButton = BrowseButton;
const HiddenInput = _styledComponents.default.input`
  display: none;
`;
exports.HiddenInput = HiddenInput;
const FilesWrapper = _styledComponents.default.div`
  ${({
  $disabled
}) => (0, _styledComponents.css)`
    display: flex;
    flex-direction: column;
    flex: 1;
    max-height: 27.7rem;
    overflow-y: auto;
    padding-right: 2rem;
    width: 100%;

    ${$disabled && (0, _styledComponents.css)`
      pointer-events: none;
      opacity: 0.4;
    `}
  `}
`;
exports.FilesWrapper = FilesWrapper;
const FilePreview = _styledComponents.default.div`
  ${({
  theme
}) => (0, _styledComponents.css)`
    display: flex;
    width: 100%;
    gap: 1rem;
    padding: 1rem 1.5rem;
    align-items: center;
    color: ${(0, _polished.lighten)(0.3, theme.colors.primaryDark)};
    font-size: ${theme.fonts.sizes.small};
    border-bottom: 0.1rem solid ${(0, _polished.lighten)(0.8, theme.colors.primaryDark)};

    &:first-of-type {
      border-top: 0.1rem solid ${(0, _polished.lighten)(0.8, theme.colors.primaryDark)};
    }

    &:hover {
      background-image: linear-gradient(
        45deg, ${(0, _polished.opacify)(0.025, theme.colors.blackOpacity)}, transparent
      );
      font-weight: ${theme.fonts.weight.medium};
    }

    svg {
      min-height: 2.5rem;
      min-width: 2.5rem;
      color: ${theme.colors.secondary};
    }
  `}
`;
exports.FilePreview = FilePreview;
const FileName = _styledComponents.default.p`
  height: fit-content;
  margin-top: 0.1rem;
  max-width: 85%;
  overflow: hidden;
  text-overflow: ellipsis;
`;
exports.FileName = FileName;
const CloseButton = (0, _styledComponents.default)(_IoCloseSharp.IoCloseSharp)`
  ${({
  theme
}) => (0, _styledComponents.css)`
    height: 1rem;
    width: 1rem;
    margin-left: auto;

    &:hover {
      color: ${(0, _polished.lighten)(0.15, theme.colors.secondary)};
    }

    &:active {
      color: ${(0, _polished.darken)(0.03, theme.colors.secondary)};
    }
  `}
`;
exports.CloseButton = CloseButton;
const Error = _styledComponents.default.p`
  ${({
  theme
}) => (0, _styledComponents.css)`
    color: ${theme.colors.error};
    font-size: ${theme.fonts.sizes.small};
  `}
`;
exports.Error = Error;